import React, { useEffect, useState, useRef } from "react";
import { useAccountContext } from "../context/AccountContext";
import electronBridge from '../utils/electronBridge';
import { isFreeUser } from '../utils/accountTypes';
import Modal from "../components/Modal";
import CloseIcon from "../images/icons/white-close.svg"
import { useNavigate, useLocation } from "react-router-dom";

export default function ComfyUI() {
  const [isActive, setIsActive] = useState(false);
  const [portNumber, setPortNumber] = useState(8288);
  const [workflowSent, setWorkflowSent] = useState(false);
  const accountContext = useAccountContext();
  const navigate = useNavigate();
  const location = useLocation();
  const iframeRef = useRef(null);
  const url = `http://localhost:${portNumber}/`;
  const [customUrlFailed, setCustomUrlFailed] = useState(false);

  // Check if we have a workflow to load from navigation state
  const workflowToLoad = location.state?.workflowToLoad;
  const cosyflowTitle = location.state?.cosyflowTitle;


  const ipcRenderer = electronBridge.ipcRenderer

  // Utility function to try custom protocol with fallback
  const tryProtocolWithFallback = (protocolUrl, fallbackUrl) => {
    let hasBlurred = false;
    let timeoutId;

    const cleanup = () => {
      window.removeEventListener('blur', handleBlur);
      if (timeoutId) clearTimeout(timeoutId);
    };

    const handleBlur = () => {
      hasBlurred = true;
      cleanup();
    };

    // Add blur listener to detect if protocol launched successfully
    window.addEventListener('blur', handleBlur);

    // Set timeout for fallback
    timeoutId = setTimeout(() => {
      if (!hasBlurred) {
        cleanup();
        // Protocol likely failed, redirect to fallback
        window.open(fallbackUrl, '_blank');
      }
    }, 1500);

    // Try the protocol
    try {
      window.location.assign(protocolUrl);
    } catch (error) {
      // If immediate error, cleanup and go to fallback
      cleanup();
      window.open(fallbackUrl, '_blank');
    }
  };

  useEffect(() => {
    fetch(url, {mode: "no-cors"})
    .then(() => {
        setIsActive(true)
    })
    .catch(() => {
        setIsActive(false)
    })

    if (isFreeUser() && !electronBridge.isElectron) {
      setCustomUrlFailed(true)
    }
  }, []);

  // 🔹 Listen for messages FROM ComfyUI (iframe)
  useEffect(() => {
    function handleMessage(event) {
      // Only accept messages from ComfyUI origin
      if (event.origin !== `http://localhost:${portNumber}`) return;

      const data = event.data || {};
      const type = data.type;
      const payload = data.payload;

      console.log("[React_COMFYUI] message from ComfyUI: ", type, payload);

      if (type === "COMFY_SHARE_STARTED") {
        console.log("[React_COMFYUI] message from ComfyUI inside if: ", type, payload);

        const incomingCosyflow = payload?.data?.cosyflow;

        if (incomingCosyflow) {
          const cosyflowInner = {
            title: incomingCosyflow.title || "",
            description: incomingCosyflow.description || "",
            category: incomingCosyflow.tags?.[0] || null,
            workflow: incomingCosyflow.workflow || {},
            prompt: incomingCosyflow.prompt || {},
            assignments: incomingCosyflow.assignments || [],
            variables: incomingCosyflow.variables || {}
          };

          const cosyflowData = {
            trusted: "0",
            public: "0",
            distributed: "0",
            title: incomingCosyflow.title || "",
            description: incomingCosyflow.description || "",
            cosyflow: JSON.stringify(cosyflowInner),
            category: incomingCosyflow.tags?.[0] || null
          };
          console.log("[React_COMFYUI] Compiled Cosyflow Data from ComfyUI: ", cosyflowData);

          navigate("/cosyflow-editor", { state: { importedCosyflow: cosyflowData, isNewFromComfyUI: true } });
        } else {
          console.warn("[React_COMFYUI] No cosyflow data in payload");
        }
      }
    }

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [portNumber]);

  // 🔹 Send workflow TO ComfyUI when iframe is ready and we have a workflow to load
  // useEffect(() => {
  //   if (isActive && workflowToLoad && iframeRef.current && !workflowSent) {
  //     // Wait a bit for ComfyUI to fully initialize
  //     const timeoutId = setTimeout(() => {
  //       console.log("[React_COMFYUI] Sending workflow to ComfyUI:", cosyflowTitle, workflowToLoad);

  //       // Send the workflow via postMessage
  //       iframeRef.current.contentWindow.postMessage({
  //         type: 'LOAD_WORKFLOW',
  //         payload: {
  //           workflow: workflowToLoad,
  //           title: cosyflowTitle
  //         }
  //       }, `http://localhost:${portNumber}`);

  //       setWorkflowSent(true);
  //     }, 2000); // Give ComfyUI 2 seconds to fully initialize

  //     return () => clearTimeout(timeoutId);
  //   }
  // }, [isActive, workflowToLoad, cosyflowTitle, portNumber, workflowSent]);
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type === "COMFYUI_READY" && workflowToLoad && iframeRef.current && !workflowSent) {
        console.log("[React] ComfyUI is ready, sending workflow:", cosyflowTitle);

        iframeRef.current.contentWindow.postMessage({
          type: 'LOAD_WORKFLOW',
          payload: {
            workflow: workflowToLoad,
            title: cosyflowTitle
          }
        }, `http://localhost:${portNumber}`);

        setWorkflowSent(true);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [workflowToLoad, cosyflowTitle, portNumber, workflowSent]);

   useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type === "WORKFLOW_LOADED") {
        console.log("[React_COMFYUI] Workflow load result:", event.data.payload);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const reloadPage = () => {
    window.location.reload();
  }

  const handleOpenManager = () => {
    if (electronBridge.isElectron) {
      ipcRenderer.send('open-pmanager', accountContext.accountDetails.accountNo, accountContext.accountDetails.alias, window.localStorage.getItem('longLifeAPIKey'))
    } else {
      const protocolUrl = `promptus-pm:/accountNo=${accountContext.accountDetails.accountNo},alias=${accountContext.accountDetails.alias},apiKey=${window.localStorage.getItem('longLifeAPIKey')}`;
      const fallbackUrl = `https://login.promptus.ai/auto-signin?v=${accountContext.accountDetails.verificationToken}&e=${accountContext.accountDetails.emailHash}&a=${accountContext.accountDetails.accountNo}&r=/subscriptions`;
      tryProtocolWithFallback(protocolUrl, fallbackUrl);
    }
  }
  const openSubPage = () => {
    window.open(`https://login.promptus.ai/auto-signin?v=${accountContext.accountDetails.verificationToken}&e=${accountContext.accountDetails.emailHash}&a=${accountContext.accountDetails.accountNo}&r=/subscriptions`, '_blank');
  }

  return isActive ? (
    <div className="w-full h-full relative">
      {/* Title bar overlay - only in Electron to prevent iframe from capturing clicks on window controls */}
      {electronBridge.isElectron && (
        <div
          className="absolute top-0 left-0 right-0 h-1 z-50"
          style={{ WebkitAppRegion: 'drag' }}
        />
      )}
      {/* Show loading indicator when sending workflow */}
      {workflowToLoad && !workflowSent && (
        <div className="absolute top-4 left-1/2 transform -translate-x-1/2 z-50 bg-yellow text-dark-blue px-4 py-2 rounded-lg font-medium shadow-lg">
          Loading workflow: {cosyflowTitle}...
        </div>
      )}
      <iframe ref={iframeRef} src={url} className="w-full h-full" />
    </div>
  ) : (
    <>
      <div className="w-full h-full flex flex-col items-center justify-center backdrop-blur">
        <div className="flex flex-row items-end mb-12">
          <p className="text-4xl font-semibold uppercase">LOCAL COMFYUI IS CURRENTLY OFFLINE</p>
            <span className="w-2 h-2 mb-1 ms-1 bg-white rounded-full animate-ellipsis"></span>
            <span className="w-2 h-2 mb-1 bg-white rounded-full animate-ellipsis delay-150"></span>
            <span className="w-2 h-2 mb-1 bg-white rounded-full animate-ellipsis delay-300"></span>
          </div>
        <div className="flex flex-col items-center">
          <hr className={"w-full border border-white bg-white"}/>
          <div className="flex flex-col items-center my-5 bg-dark-blue/40 p-2">
            <p className="text-lg font-medium">It seems your ComfyUI is not running yet if want to run ComfyUI</p>
            <p className="text-lg font-medium">you will need to install and run it from the PManager app.</p>
            {accountContext.loggedIn ?
              <>
                <p className="text-lg font-medium">If you haven't installed and ran it click the button to do so now</p>
                <a onClick={handleOpenManager} 
                  className="rounded w-1/2 mx-auto mt-4 mb-3 p-2 bg-yellow text-center text-dark-blue shadow font-bold cursor-pointer"
                >Open Manager</a>
              </>
            :
              <p className="text-lg font-medium">Please login and install ComfyUI to run it</p>
            }
          </div>
          <hr className={"w-full border border-white bg-white"}/>
          <div className="flex flex-col items-center my-5 bg-dark-blue/40 p-2">
            <p className="text-lg font-medium">Once your ComfyUI is running please type in the port of where</p>
            <p className="text-lg font-medium">your ComfyUI is hosted on:</p>
            <input type="number" className="w-28 h-10 mt-2 mb-3 justify-center text-black text-center" value={portNumber} onChange={(e) => setPortNumber(e.value)}/>
          <button onClick={reloadPage} className={`rounded-lg bg-yellow py-2 px-5 shadow-xl font-bold text-lg uppercase`}>Refresh Page</button>
          </div>
        </div>
      {customUrlFailed && (
        <div 
        className={"fixed inset-0 z-[999] flex items-center justify-center p-4 bg-dark-blue/40 backdrop-blur overflow-y-auto"}
        style={{ pointerEvents: 'auto' }}
      >
        <div id="comfyUI_popup" className="w-full max-w-3xl mx-auto my-8 flex flex-col">
          <div className={"w-full bg-dark-blue flex flex-col px-6 py-4 rounded-t-3xl"}>
              <span role="image" className={"mx-auto mt-5 text-4xl"}>🚀</span>
              <span className="mx-auto mt-5 text-3xl flex flex-col text-center font-bold">Unlock AI Creativity with <span className="text-cyan">ComfyUI</span></span>
              {/* <button className={"px-3 py-2 rounded-lg bg-dark-blue/60 text-white hover:bg-dark-blue hover:text-yellow transition-all"} onClick={() => setCustomUrlFailed(false)}>
                  <img src={CloseIcon} alt='Close Image' className='h-6 w-6'/>
              </button> */}
          </div>
          <div className="w-full bg-dark-blue flex flex-col py-8 px-5 rounded-b-3xl">
            <div id="price-box" className="flex flex-col bg-cyan/20 border border-cyan/30 h-24 mx-18 rounded-2xl justify-center items-center">
                <div className="w-full flex flex-row justify-center mb-2">
                  <span className="text-4xl text-cyan font-extrabold"><span className="text-2xl font-bold">$</span>49 <span className="text-2xl text-white font-normal">One-Time</span></span>
                </div>
                <div>
                  No Monthly Fees &bull; Lifetime Access
                </div>
            </div>
            <div id="vanilla_text" className="mt-8 mb-3 text-xl text-center">
                Skip the setup stress. Start creating stunning AI art, videos, and 3D content instantly with our complete ComfyUI
            </div>
            <div id="mini_boxes" className="grid grid-cols-2 grid-rows-2 gap-4 mt-5 mx-3">
                <div className="col-span-1 flex flex-row grid-rows-2 bg-cyan/20 rounded-lg h-24 border border-gray-600">
                  <div className="flex flex-col justify-start w-24 p-5">
                    <span role="image" className="bg-cyan/30 p-1 text-center text-2xl rounded-xl border border-cyan/40">🛠️</span>
                  </div>
                  <div className="flex flex-col py-3">
                    <span className="font-bold text-xl">One-Time Setup</span>
                    <span>Windows ready. No tech hassle, just launch and create</span>
                  </div>
                </div>
                <div className="col-span-1 flex flex-row grid-rows-2 bg-cyan/20 rounded-lg h-24 border border-gray-600">
                  <div className="flex flex-col justify-start w-24 p-5">
                    <span role="image" className="bg-cyan/30 p-1 text-center text-2xl rounded-xl border border-cyan/40">🚀</span>
                  </div>
                  <div className="flex flex-col py-3">
                    <span className="font-bold text-xl">100+ Preloaded Models</span>
                    <span>SD, Flux, LTXV and more. Best tools ready to go.</span>
                  </div>
                </div>
                <div className="col-span-1 flex flex-row grid-rows-2 bg-cyan/20 rounded-lg h-24 border border-gray-600">
                  <div className="flex flex-col justify-start w-24 p-5">
                    <span role="image" className="bg-cyan/30 p-1 text-center text-2xl rounded-xl border border-cyan/40">🤖</span>
                  </div>
                  <div className="flex flex-col py-3">
                    <span className="font-bold text-xl">AI Integration</span>
                    <span>Gemini & GPT-4o for smarter prompting and better results.</span>
                  </div>
                </div>
                <div className="col-span-1 flex flex-row grid-rows-2 bg-cyan/20 rounded-lg h-24 border border-gray-600">
                  <div className="flex flex-col justify-start w-24 p-5">
                    <span role="image" className="bg-cyan/30 p-1 text-center text-2xl rounded-xl border border-cyan/40">💾</span>
                  </div>
                  <div className="flex flex-col py-3">
                    <span className="font-bold text-xl">Offline Generations</span>
                    <span>Unlimited generations, download models, create professional content.</span>
                  </div>
                </div>
            </div>
            <button id="getComfy_button" className="mt-9 w-fit mx-auto text-xl font-bold px-8 py-5 bg-[#04bfaf] rounded-xl shadow-[0_0_10px_#ffffff] hover:shadow-[0_0_15px_#ffffff]" onClick={openSubPage}>
                Get ComfyUI Now &rarr;
            </button>
            <div id="guarantee" className="mx-auto w-fit bg-cyan/30 border border-cyan/40 mt-5 p-2 px-3 rounded-3xl font-bold text-lg">
                🔄️ 30-Day Money-Back Guarantee
            </div>
            <hr id="footer-divider" className="w-[90%] border-gray-600 mt-7 mx-auto" />
            <div id="footer" className="mt-5 flex flex-row w-full justify-center gap-4">
                <span>👥 10000+ creators</span>
                <span>⭐ 4.9/5 Rating</span>
                <span>🔐 Secure Payment</span>
            </div>
          </div>
        </div>
      </div>
        // <Modal 
        //     heading={
        //       <div className="flex items-center gap-3 text-yellow">
        //         <span className="font-bold">Buy PWA</span>
        //       </div>
        //     }
        //     closeEvent={() => setCustomUrlFailed(false)}
        //   >
        //     <div className="bg-dark-blue h-32">
        //       Buy PWA now
        //       <button onClick={openSubPage} className={`rounded-lg bg-yellow py-2 px-5 shadow-xl font-bold text-lg uppercase`}>Buy PWA</button>
        //     </div>
        //   </Modal>
      )

      }
      </div>
    </>
  );
}
